<script>
import axios from 'axios';

import catalogTextListMixin from './catalogTextListMixin.vue';

export default {
  mixins: [catalogTextListMixin],
  data() {
    return {
      mediaDownloadLink: null,
    };
  },
  computed: {
    catalogService() {
      let url;
      switch (APP_ENVIRONMENT) {
        case 'PROD':
          url = 'https://api.fischer.group/catalog/v1/';
          break;
        case 'UAT':
          url = 'https://api-uat.fischer.group/catalog/v1/';
          break;
        default:
          url = 'https://api-test.fischer.group/catalog/v1/';
          break;
      }
      return url;
    },
  },
  methods: {
    checkForMediaDownload({ type, id }) {
      const lang =
        this.$fischer.catalogLocale() ||
        (this.$fischer.siteLanguage() || '').replace('-', '_') ||
        'de_DE';
      const url = `${this.catalogService}media/${type}/${id}/${this.$fischer.brandId()}/${lang}`;
      this.mediaDownloadLink = url;

      if (IS_SSR) {
        return;
      }
      try {
        // note: not using async to allow SSR without prefetch
        axios.head(url).then((res) => {
          if (res.status === 204) {
            this.mediaDownloadLink = null;
          }
        });
      } catch (error) {
        console.info(error);
        this.mediaDownloadLink = null;
      }
    },
    getFamilyThumbnails(catalogData) {
      if (!catalogData?.Media) {
        return [];
      }
      return catalogData.Media.filter(
        (media) =>
          (media.OutputType === 'PR' &&
            (media.Type === 'Product Picture' ||
              media.Type === 'Product Category Picture' ||
              media.Type === 'Packaging' ||
              media.Type === 'Application Picture')) ||
          (media.OutputType === 'IS' && media.Type === 'Video'),
      );
    },
  },
};
</script>
